export const preloadedFonts = [
  {
    id: "anak-paud",
    fileName: "anak-paud.ttf",
    fontName: "Anak Paud",
    fontFamily: "Anak Paud",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/anak-paud.ttf"),
    isPreloaded: true,
  },
  {
    id: "babybrooklynnregular-medium",
    fileName: "babybrooklynnregular-medium.ttf",
    fontName: "Babybrooklynnregular Medium",
    fontFamily: "babybrooklynnregular Medium",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/babybrooklynnregular-medium.ttf"),
    isPreloaded: true,
  },
  {
    id: "bakery-holland",
    fileName: "bakery-holland.ttf",
    fontName: "Bakery Holland",
    fontFamily: "Bakery Holland",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/bakery-holland.ttf"),
    isPreloaded: true,
  },
  {
    id: "baloo-regular",
    fileName: "baloo-regular.ttf",
    fontName: "Baloo Regular",
    fontFamily: "Baloo",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/baloo-regular.ttf"),
    isPreloaded: true,
  },
  {
    id: "barbiedaddy",
    fileName: "barbiedaddy.otf",
    fontName: "Barbiedaddy",
    fontFamily: "Barbie Daddy",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/barbiedaddy.otf"),
    isPreloaded: true,
  },
  {
    id: "bebasneue-regular",
    fileName: "bebasneue-regular.ttf",
    fontName: "Bebasneue Regular",
    fontFamily: "Bebas Neue",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/bebasneue-regular.ttf"),
    isPreloaded: true,
  },
  {
    id: "berkshireswash-regular",
    fileName: "berkshireswash-regular.ttf",
    fontName: "Berkshireswash Regular",
    fontFamily: "Berkshire Swash Bold",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/berkshireswash-regular.ttf"),
    isPreloaded: true,
  },
  {
    id: "caveat-bold",
    fileName: "caveat-bold.ttf",
    fontName: "Caveat Bold",
    fontFamily: "Caveat Bold",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/caveat-bold.ttf"),
    isPreloaded: true,
  },
  {
    id: "chrisye",
    fileName: "chrisye.otf",
    fontName: "Chrisye",
    fontFamily: "Chrisye",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/chrisye.otf"),
    isPreloaded: true,
  },
  {
    id: "clap-hand",
    fileName: "clap-hand.ttf",
    fontName: "Clap Hand",
    fontFamily: "Clap Hand",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/clap-hand.ttf"),
    isPreloaded: true,
  },
  {
    id: "daggersquare-oblique",
    fileName: "daggersquare-oblique.otf",
    fontName: "Daggersquare Oblique",
    fontFamily: "DAGGERSQUARE",
    fontSubfamily: "OBLIQUE",
    weight: 400,
    src: require("../assets/fonts/daggersquare-oblique.otf"),
    isPreloaded: true,
  },
  {
    id: "daggersquare",
    fileName: "daggersquare.otf",
    fontName: "Daggersquare",
    fontFamily: "DAGGERSQUARE",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/daggersquare.otf"),
    isPreloaded: true,
  },
  {
    id: "daniel-black",
    fileName: "daniel-black.otf",
    fontName: "Daniel Black",
    fontFamily: "Daniel Black Bold",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/daniel-black.otf"),
    isPreloaded: true,
  },
  {
    id: "emilio-20",
    fileName: "emilio-20.ttf",
    fontName: "Emilio 20",
    fontFamily: "Emilio 20",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/emilio-20.ttf"),
    isPreloaded: true,
  },
  {
    id: "exo-bold-italic",
    fileName: "exo-bold-italic.otf",
    fontName: "Exo Bold Italic",
    fontFamily: "Exo Bold",
    fontSubfamily: "Bold Italic",
    weight: 700,
    src: require("../assets/fonts/exo-bold-italic.otf"),
    isPreloaded: true,
  },
  {
    id: "exo-bold",
    fileName: "exo-bold.otf",
    fontName: "Exo Bold",
    fontFamily: "Exo Bold",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/exo-bold.otf"),
    isPreloaded: true,
  },
  {
    id: "facon",
    fileName: "facon.ttf",
    fontName: "Facon",
    fontFamily: "Facon Bold",
    fontSubfamily: "Bold Italic",
    weight: 700,
    src: require("../assets/fonts/facon.ttf"),
    isPreloaded: true,
  },
  {
    id: "france-2022",
    fileName: "france-2022.otf",
    fontName: "France 2022",
    fontFamily: "France 2022",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/france-2022.otf"),
    isPreloaded: true,
  },
  {
    id: "gooddp__.ttf",
    fileName: "gooddp__.ttf.ttf",
    fontName: "Gooddp__.ttf",
    fontFamily: "GoodDog Plain",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/gooddp__.ttf.ttf"),
    isPreloaded: true,
  },
  {
    id: "happy-selfie",
    fileName: "happy-selfie.ttf",
    fontName: "Happy Selfie",
    fontFamily: "Happy Selfie",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/happy-selfie.ttf"),
    isPreloaded: true,
  },
  {
    id: "happymonkey-regular",
    fileName: "happymonkey-regular.ttf",
    fontName: "Happymonkey Regular",
    fontFamily: "Happy Monkey",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/happymonkey-regular.ttf"),
    isPreloaded: true,
  },
  {
    id: "justanotherhand",
    fileName: "justanotherhand.ttf",
    fontName: "Justanotherhand",
    fontFamily: "Just Another Hand",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/justanotherhand.ttf"),
    isPreloaded: true,
  },
  {
    id: "justforfun-regular",
    fileName: "justforfun-regular.ttf",
    fontName: "Justforfun Regular",
    fontFamily: "Just For Fun",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/justforfun-regular.ttf"),
    isPreloaded: true,
  },
  {
    id: "laliga-23-24",
    fileName: "laliga-23-24.otf",
    fontName: "Laliga 23 24",
    fontFamily: "Laliga 23-24",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/laliga-23-24.otf"),
    isPreloaded: true,
  },
  {
    id: "lapsuspro-bold",
    fileName: "lapsuspro-bold.otf",
    fontName: "Lapsuspro Bold",
    fontFamily: "Lapsus Pro (theguybrush.com) Bold",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/lapsuspro-bold.otf"),
    isPreloaded: true,
  },
  {
    id: "leaguegothic-regular",
    fileName: "leaguegothic-regular.otf",
    fontName: "Leaguegothic Regular",
    fontFamily: "League Gothic",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/leaguegothic-regular.otf"),
    isPreloaded: true,
  },
  {
    id: "magnolia-script",
    fileName: "magnolia-script.otf",
    fontName: "Magnolia Script",
    fontFamily: "Magnolia Script",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/magnolia-script.otf"),
    isPreloaded: true,
  },
  {
    id: "mango-nice",
    fileName: "mango-nice.ttf",
    fontName: "Mango Nice",
    fontFamily: "Mango Nice",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/mango-nice.ttf"),
    isPreloaded: true,
  },
  {
    id: "marimpa",
    fileName: "marimpa.ttf",
    fontName: "Marimpa",
    fontFamily: "Marimpa",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/marimpa.ttf"),
    isPreloaded: true,
  },
  {
    id: "merriweather-bold",
    fileName: "merriweather-bold.ttf",
    fontName: "Merriweather Bold",
    fontFamily: "Merriweather Bold",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/merriweather-bold.ttf"),
    isPreloaded: true,
  },
  {
    id: "monospacebold",
    fileName: "monospacebold.ttf",
    fontName: "Monospacebold",
    fontFamily: "Monospace Bold",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/monospacebold.ttf"),
    isPreloaded: true,
  },
  {
    id: "moresugar-regular",
    fileName: "moresugar-regular.otf",
    fontName: "Moresugar Regular",
    fontFamily: "More Sugar",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/moresugar-regular.otf"),
    isPreloaded: true,
  },
  {
    id: "netherland-2022-back-number",
    fileName: "netherland-2022-back-number.otf",
    fontName: "Netherland 2022 Back Number",
    fontFamily: "Netherland 2022 Back Number",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/netherland-2022-back-number.otf"),
    isPreloaded: true,
  },
  {
    id: "neuropol",
    fileName: "neuropol.otf",
    fontName: "Neuropol",
    fontFamily: "Neuropol",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/neuropol.otf"),
    isPreloaded: true,
  },
  {
    id: "northface",
    fileName: "northface.ttf",
    fontName: "Northface",
    fontFamily: "North Face",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/northface.ttf"),
    isPreloaded: true,
  },
  {
    id: "octin-sports-rg",
    fileName: "octin-sports-rg.otf",
    fontName: "Octin Sports Rg",
    fontFamily: "Octin Sports",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/octin-sports-rg.otf"),
    isPreloaded: true,
  },
  {
    id: "patrickhand-regular",
    fileName: "patrickhand-regular.ttf",
    fontName: "Patrickhand Regular",
    fontFamily: "Patrick Hand",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/patrickhand-regular.ttf"),
    isPreloaded: true,
  },
  {
    id: "permanentmarker",
    fileName: "permanentmarker.ttf",
    fontName: "Permanentmarker",
    fontFamily: "Permanent Marker",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/permanentmarker.ttf"),
    isPreloaded: true,
  },
  {
    id: "premier-league-23-24",
    fileName: "premier-league-23-24.otf",
    fontName: "Premier League 23 24",
    fontFamily: "Premier League 23-24",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/premier-league-23-24.otf"),
    isPreloaded: true,
  },
  {
    id: "roboto-bold",
    fileName: "roboto-bold.ttf",
    fontName: "Roboto Bold",
    fontFamily: "Roboto",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/roboto-bold.ttf"),
    isPreloaded: true,
  },
  {
    id: "simple-notes-font-by-keithzo",
    fileName: "simple-notes-font-by-keithzo.otf",
    fontName: "Simple Notes Font By Keithzo",
    fontFamily: "Simple Notes",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/simple-notes-font-by-keithzo.otf"),
    isPreloaded: true,
  },
  {
    id: "soccerleague",
    fileName: "soccerleague.ttf",
    fontName: "Soccerleague",
    fontFamily: "Soccer League",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/soccerleague.ttf"),
    isPreloaded: true,
  },
  {
    id: "theaterv04_bold",
    fileName: "theaterv04_bold.ttf",
    fontName: "Theaterv04_bold",
    fontFamily: "Theater Bold",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/theaterv04_bold.ttf"),
    isPreloaded: true,
  },
  {
    id: "theboldfont-freeversion",
    fileName: "theboldfont-freeversion.ttf",
    fontName: "Theboldfont Freeversion",
    fontFamily: "THE BOLD FONT (FREE VERSION)",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/theboldfont-freeversion.ttf"),
    isPreloaded: true,
  },
  {
    id: "tropical-morning",
    fileName: "tropical-morning.ttf",
    fontName: "Tropical Morning",
    fontFamily: "Tropical Morning",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/tropical-morning.ttf"),
    isPreloaded: true,
  },
  {
    id: "ubuntu-b",
    fileName: "ubuntu-b.ttf",
    fontName: "Ubuntu B",
    fontFamily: "Ubuntu Bold",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/ubuntu-b.ttf"),
    isPreloaded: true,
  },
  {
    id: "usa-2022",
    fileName: "usa-2022.otf",
    fontName: "Usa 2022",
    fontFamily: "USA 2022",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/usa-2022.otf"),
    isPreloaded: true,
  },
  {
    id: "varsityteam-bold",
    fileName: "varsityteam-bold.otf",
    fontName: "Varsityteam Bold",
    fontFamily: "Varsity Team Bold",
    fontSubfamily: "Bold",
    weight: 700,
    src: require("../assets/fonts/varsityteam-bold.otf"),
    isPreloaded: true,
  },
  {
    id: "wedges",
    fileName: "wedges.ttf",
    fontName: "Wedges",
    fontFamily: "Wedges",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/wedges.ttf"),
    isPreloaded: true,
  },
  {
    id: "wellfleet-regular",
    fileName: "wellfleet-regular.ttf",
    fontName: "Wellfleet Regular",
    fontFamily: "Wellfleet",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/wellfleet-regular.ttf"),
    isPreloaded: true,
  },
  {
    id: "wonderful-handwriting",
    fileName: "wonderful-handwriting.otf",
    fontName: "Wonderful Handwriting",
    fontFamily: "Wonderful Handwriting",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/wonderful-handwriting.otf"),
    isPreloaded: true,
  },
  {
    id: "worktalk",
    fileName: "worktalk.ttf",
    fontName: "Worktalk",
    fontFamily: "Worktalk",
    fontSubfamily: "Regular",
    weight: 400,
    src: require("../assets/fonts/worktalk.ttf"),
    isPreloaded: true,
  },
];

export const getPreloadedFontsMenuOptions = () => {
  return preloadedFonts.map((font) => ({
    value: font.fontFamily,
    label: font.fontName,
  }));
};

export const determineIsPreloaded = (fontName: string) => {
  return preloadedFonts.some((font) => font.fontName === fontName);
};

export const getPreloadedFontObject = (fontName: string) => {
  return preloadedFonts.find((font) => font.fontName === fontName) || null;
};
